import { z } from 'zod';

export const FixedAssetSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  name: z.string(),
  assetAccountId: z.string(),
  accumulatedDepreciationAccountId: z.string(),
  depreciationExpenseAccountId: z.string(),
  purchaseDate: z.string(),
  purchasePrice: z.number(),
  salvageValue: z.number(),
  usefulLifeMonths: z.number(),
  depreciationMethod: z.enum(['Straight-Line', 'Declining Balance']),
  status: z.enum(['Active', 'Disposed']),
});

export type FixedAsset = z.infer<typeof FixedAssetSchema>;

export const DepreciationScheduleLineSchema = z.object({
  date: z.string(),
  amount: z.number(),
  journalEntryId: z.string().optional(),
});

export type DepreciationScheduleLine = z.infer<typeof DepreciationScheduleLineSchema>;
